// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import AppstoreOutlined from '/app/frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
import CrownOutlined from '/app/frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import DashboardOutlined from '/app/frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import ClusterOutlined from '/app/frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ClusterOutlined';
import DollarOutlined from '/app/frontend/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DollarOutlined';
export default { AppstoreOutlined, CrownOutlined, DashboardOutlined, ClusterOutlined, DollarOutlined };
